
/**
  * Saved Favorites handler
  *
  */
//console.log(tgblPEFrontend_e)
const PELabFrontendCommon = ($) => {

  return;
  if (!window.Tangible) return

  const tangibleSelect = window.Tangible.Select
  const ajax = window.Tangible.ajax
  const ajaxConfig = window.Tangible.ajaxConfig

  const tgblPEFrontend_json = window.atob(tgblPEFrontend_e)
  const tgblPEFrontend = jQuery.parseJSON(tgblPEFrontend_json)
  const LOCALIZED = tgblPEFrontend.localized

  //console.log(tgblPEFrontend)

  // Global object
  window.PELabFCommon = {}

  $(document).ready(function () {
    window.PELabFCommon.constructor()
  })

  window.PELabFCommon = {

    // initialize the code
    constructor: function () {

      const $_this =this;

      // TEST TABLES CURL-REST TODO : remove eventually
      const tgbl_test_table_api__js = $('.tgbl_test_table_api--js')
      if(tgbl_test_table_api__js.length) {
        this.testRest(tgbl_test_table_api__js,$_this)
      }
    },

    testRest: function (parent,$_this) {

      //console.log(parent)

      $('body').on('click','.tgbl_test_table_api--js .trigger-api',function(){

        const $this = $(this)
        const user_id = $this.attr('data-user_id')
        const course_id = $this.attr('data-course_id')

        const data = {
          user_id: user_id,
          course_id: course_id,
        }
        console.log('data ',  data)

        // ajax handle user saved favorite remove

        ajax('tgbl_test_table_api_ajax', data)
          .then(function(res) {

            console.log('RESPONSE --- ',  res)
            if(res){

              //console.log('RESPONSE --- ',  res)

              parent.find('.test_table_api_response').html(JSON.stringify(res))
            }
          })
          .catch(function(err) {
            console.log('error - ',  err)
          }) // end ajax
      }) // end click
    },
  }
}
export {PELabFrontendCommon}
